export enum EndType {
  never = 'NEVER',
  until = 'UNTIL'
}

export enum MonthType {
  SPECIFIC_DAY = 'specific_day',
  WEEKDAY = 'weekday'
}

export enum WeekOption {
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
  FIFTH = 5,
  LAST = -1
}
